
  import { getsafe } from '@/libs/util.js'
export default {
    methods: {
        getParams() {
         
            return getsafe(this.$route, 'query', {}) || {}
        }
    }
}